module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-center",
    attrs: {
      "id": "home"
    }
  }, [_c('agile', {
    attrs: {
      "arrows": false,
      "speed": 1000,
      "timing": 'linear',
      "fade": true,
      "autoplay": true
    }
  }, _vm._l((_vm.slides), function(slide) {
    return _c('div', {
      staticClass: "slide slide--1"
    }, [_c('img', {
      attrs: {
        "src": slide.img,
        "alt": "Slide 1"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slider-caption"
    }, [_c('div', {
      staticClass: "templatemo_homewrapper"
    }, [_c('h1', {
      staticClass: "wow fadeInDown",
      attrs: {
        "data-wow-delay": "2000"
      }
    }, [_vm._v(_vm._s(slide.title))]), _vm._v(" "), _c('h2', {
      staticClass: "wow fadeInDown",
      attrs: {
        "data-wow-delay": "2000"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(slide.info)
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(slide.details)
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#' + slide.href),
        expression: "'#' + slide.href"
      }],
      staticClass: "smoothScroll btn btnS btn-Kirnil wow fadeInDown",
      attrs: {
        "data-wow-delay": "2000"
      }
    }, [_vm._v(_vm._s(slide.urlTitle))])])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64acbe57!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/slides.vue
// module id = 719
// module chunks = 0